import ActiveCampaign from "./reducedLogos/Active Campaign.png";
import AddEvent from "./reducedLogos/AddEvent.png";
import Adobe_Bridge from "./reducedLogos/Adobe Bridge.png";
import Adobe_Dimension from "./reducedLogos/Adobe Dimension.png";
import Adobe_Illustrator from "./reducedLogos/Adobe Illustrator Integrations Logo-1600.png";
import Adobe_InDesign from "./reducedLogos/Adobe InDesign.png";
import Adobe_Lightroom from "./reducedLogos/Adobe Lightroom.png";
import Adobe_Photoshop from "./reducedLogos/Adobe Photoshop Integrations Logo-1600.png";
import Adobe_Premiere from "./reducedLogos/Adobe Premiere Pro.png";
import Adobe_XD from "./reducedLogos/Adobe XD Integrations Logo-1600.png";
import Adobe from "./reducedLogos/Adobe.png";
import Airtable from "./reducedLogos/Airtable.png";
import Alexa from "./reducedLogos/Alexa.png";
import Apple from "./reducedLogos/Apple.png";
import Asana from "./reducedLogos/Asana.png";
import Atlassian from "./reducedLogos/Atlassian.png";
import AWS_Lightsail from "./reducedLogos/AWS Lightsail.png";
import AWS from "./reducedLogos/AWS.png";
import Azure_Functions from "./reducedLogos/Azure Functions Integrations Logo-1600.png";
import Azure from "./reducedLogos/Azure.png";
import Calendly from "./reducedLogos/Calendly.png";
import Canva from "./reducedLogos/Canva.png";
import ChatGPT from "./reducedLogos/ChatGPT.png";
import ClickUp from "./reducedLogos/ClickUp.png";
import Constant_Contact from "./reducedLogos/Constant Contact.png";
import CSS3 from "./reducedLogos/CSS3.png";
import Discord from "./reducedLogos/Discord Integrations Logo-1600.png";
import DocuSign from "./reducedLogos/DocuSign Integrations Logo-1600.png";
import Dropbox from "./reducedLogos/DropBox.png";
import Facebook from "./reducedLogos/Facebook Integrations Logo-1600.png";
import Figma from "./reducedLogos/Figma.png";
import GitHub from "./reducedLogos/GitHub.png";
import Gmail from "./reducedLogos/Gmail Integrations Logo-1600.png";
import GoDaddy from "./reducedLogos/GoDaddy Integrations Logo-1600.png";
import Google_Ads from "./reducedLogos/Google Ads Integrations Logo-1600.png";
import Google_Analytics from "./reducedLogos/Google Analytics Integrations Logo-1600.png";
import Google_Calendar from "./reducedLogos/Google Calendar Integrations Logo-1600.png";
import Google_Chrome from "./reducedLogos/Google Chrome Integrations Logo-1600.png";
import Google_Docs from "./reducedLogos/Google Docs Integrations Logo-1600.png";
import Google_Drive from "./reducedLogos/Google Drive Integrations Logo-1600.png";
import Google_Fonts from "./reducedLogos/Google Fonts Integrations Logo-1600.png";
import Google_Forms from "./reducedLogos/Google Forms Integrations Logo-1600.png";
import Google_Keep from "./reducedLogos/Google Keep.png";
import Google_Maps from "./reducedLogos/Google Maps.png";
import Google_Meet from "./reducedLogos/Google Meet Integrations Logo-1600.png";
import Google_My_Business from "./reducedLogos/Google My Business.png";
import Google_Optimize from "./reducedLogos/Google Optimize Integrations Logo-1600.png";
import Google_Search_Console from "./reducedLogos/Google Search Console.png";
import Google_Sheets from "./reducedLogos/Google Sheets Integrations Logo-1600.png";
import Google_Slides from "./reducedLogos/Google Slides Integrations Logo-1600.png";
import Google_Tag_Manager from "./reducedLogos/Google Tag Manager.png";
import Google from "./reducedLogos/Google.png";
import HelloSign from "./reducedLogos/HelloSign.png";
import HTML5 from "./reducedLogos/HTML5.png";
import Hubspot_CRM from "./reducedLogos/Hubspot CRM.png";
import Hubspot_Marketing from "./reducedLogos/Hubspot Marketing.png";
import IFTTT from "./reducedLogos/IFTTT.png";
import Ignition from "./reducedLogos/Ignition.png";
import Instagram from "./reducedLogos/Instagram Integrations Logo-1600.png";
import InVision from "./reducedLogos/InVision.png";
import Javascript from "./reducedLogos/Javascript Integrations Logo-1600.png";
import Jira from "./reducedLogos/Jira.png";
import Jotform from "./reducedLogos/Jotform.png";
import Lambda from "./reducedLogos/Lambda.png";
import LinkedIn from "./reducedLogos/LinkedIn Integrations Logo-1600.png";
import LinkTree from "./reducedLogos/LinkTree.png";
import Logitech from "./reducedLogos/Logitech.png";
import Loom from "./reducedLogos/Loom.png";
import MailChimp from "./reducedLogos/MailChimp.png";
import Material_UI from "./reducedLogos/Material UI.png";
import Meta from "./reducedLogos/Meta Integrations Logo-1600.png";
import Microsoft_Excel from "./reducedLogos/Microsoft Excel Integrations Logo-1600.png";
import Microsoft_OneNote from "./reducedLogos/Microsoft OneNote.png";
import Microsoft_Outlook from "./reducedLogos/Microsoft Outlook Integrations Logo-1600.png";
import Microsoft_PowerPoint from "./reducedLogos/Microsoft PowerPoint.png";
import Microsoft_Teams from "./reducedLogos/Microsoft Teams Integrations Logo-1600.png";
import Microsoft_Word from "./reducedLogos/Microsoft Word Integrations Logo-1600.png";
import Microsoft from "./reducedLogos/Microsoft.png";
import Mural from "./reducedLogos/Mural.png";
import Nginx from "./reducedLogos/Nginx.png";
import NodeJS from "./reducedLogos/NodeJS.png";
import Notion from "./reducedLogos/Notion.png";
import OneDrive from "./reducedLogos/OneDrive.png";
import Paypal from "./reducedLogos/Paypal Integrations Logo-1600.png";
import png from "./reducedLogos/png.png";
import Power from "./reducedLogos/Power Automate.png";
import Quickbooks from "./reducedLogos/Quickbooks.png";
import React_JS from "./reducedLogos/React JS Integrations Logo-1600.png";
import Redux from "./reducedLogos/Redux.png";
import Salesforce from "./reducedLogos/Salesforce.png";
import Sanity from "./reducedLogos/Sanity.png";
import SASS from "./reducedLogos/SASS.png";
import Segment from "./reducedLogos/Segment.png";
import Sharepoint from "./reducedLogos/SharePoint.png";
import Shopify from "./reducedLogos/Shopify.png";
import ShutterStock from "./reducedLogos/ShutterStock.png";
import Slack from "./reducedLogos/Slack.png";
import sms from "./reducedLogos/sms.png";
import Spotify from "./reducedLogos/Spotify.png";
import Square from "./reducedLogos/Square.png";
import Squarespace from "./reducedLogos/Squarespace Integrations Logo-1600.png";
import Stripe from "./reducedLogos/Stripe.png";
import SVG from "./reducedLogos/svg.png";
import Trello from "./reducedLogos/Trello Integrations Logo-1600.png";
import Twilio from "./reducedLogos/Twilio.png";
import Twitter from "./reducedLogos/Twitter Integrations Logo-1600.png";
import Typeform2 from "./reducedLogos/Typeform Integrations Logo 2-1600.png";
import Typescript from "./reducedLogos/Typescript Integrations Logo-1600.png";
import Venmo from "./reducedLogos/Venmo.png";
import VS_Code from "./reducedLogos/VS Code.png";
import Webflow from "./reducedLogos/Webflow.png";
import Wix from "./reducedLogos/Wix Integrations Logo-1600.png";
import Xero from "./reducedLogos/Xero Integrations Logo-1600.png";
import Youtube from "./reducedLogos/Youtube.png";
import Zapier from "./reducedLogos/Zapier.png";
import Zendesk from "./reducedLogos/Zendesk Integrations Logo-1600.png";
import Zoom from "./reducedLogos/Zoom Integrations Logo-1600.png";

export interface Logo {
  src: string;
  name: string;
}

export const AllLogos: Logo[] = [
  { src: ActiveCampaign, name: "Active Campaign" },
  { src: AddEvent, name: "AddEvent" },
  { src: Adobe_Bridge, name: "Adobe Bridge" },
  { src: Adobe_Dimension, name: "Adobe Dimension" },
  { src: Adobe_Illustrator, name: "Adobe Illustrator" },
  { src: Adobe_InDesign, name: "Adobe InDesign" },
  { src: Adobe_Lightroom, name: "Adobe Lightroom" },
  { src: Adobe_Photoshop, name: "Adobe Photoshop" },
  { src: Adobe_Premiere, name: "Adobe Premiere" },
  { src: Adobe_XD, name: "Adobe XD" },
  { src: Adobe, name: "Adobe" },
  { src: Airtable, name: "Airtable" },
  { src: Alexa, name: "Alexa" },
  { src: Apple, name: "Apple" },
  { src: Asana, name: "Asana" },
  { src: Atlassian, name: "Atlassian" },
  { src: AWS_Lightsail, name: "AWS Lightsail" },
  { src: AWS, name: "AWS" },
  { src: Azure_Functions, name: "Azure Functions" },
  { src: Azure, name: "Azure" },
  { src: Calendly, name: "Calendly" },
  { src: Canva, name: "Canva" },
  { src: ChatGPT, name: "ChatGPT" },
  { src: ClickUp, name: "ClickUp" },
  { src: Constant_Contact, name: "Constant Contact" },
  { src: CSS3, name: "CSS3" },
  { src: Discord, name: "Discord" },
  { src: DocuSign, name: "DocuSign" },
  { src: Dropbox, name: "Dropbox" },
  { src: Facebook, name: "Facebook" },
  { src: Figma, name: "Figma" },
  { src: GitHub, name: "GitHub" },
  { src: Gmail, name: "Gmail" },
  { src: GoDaddy, name: "GoDaddy" },
  { src: Google_Ads, name: "Google Ads" },
  { src: Google_Analytics, name: "Google Analytics" },
  { src: Google_Calendar, name: "Google Calendar" },
  { src: Google_Chrome, name: "Chrome" },
  { src: Google_Docs, name: "Google Docs" },
  { src: Google_Drive, name: "Google Drive" },
  { src: Google_Fonts, name: "Google Fonts" },
  { src: Google_Forms, name: "Google Forms" },
  { src: Google_Keep, name: "Google Keep" },
  { src: Google_Maps, name: "Google Maps" },
  { src: Google_Meet, name: "Google Meet" },
  { src: Google_My_Business, name: "Google My Business" },
  { src: Google_Optimize, name: "Google Optimize" },
  { src: Google_Search_Console, name: "Google Search Console" },
  { src: Google_Sheets, name: "Google Sheets" },
  { src: Google_Slides, name: "Google Slides" },
  { src: Google_Tag_Manager, name: "Google Tag Manager" },
  { src: Google, name: "Google" },
  { src: HelloSign, name: "HelloSign" },
  { src: HTML5, name: "HTML5" },
  { src: Hubspot_CRM, name: "Hubspot" },
  { src: Hubspot_Marketing, name: "Hubspot Marketing" },
  { src: IFTTT, name: "IFTTT" },
  { src: Ignition, name: "Ignition" },
  { src: Instagram, name: "Instagram" },
  { src: InVision, name: "InVision" },
  { src: Javascript, name: "JavaScript" },
  { src: Jira, name: "Jira" },
  { src: Jotform, name: "Jotform" },
  { src: Lambda, name: "AWS Lambda" },
  { src: LinkedIn, name: "LinkedIn" },
  { src: LinkTree, name: "LinkTree" },
  { src: Logitech, name: "Logitech" },
  { src: Loom, name: "Loom" },
  { src: MailChimp, name: "MailChimp" },
  { src: Material_UI, name: "Material UI" },
  { src: Meta, name: "Meta" },
  { src: Microsoft_Excel, name: "Excel" },
  { src: Microsoft_OneNote, name: "OneNote" },
  { src: Microsoft_Outlook, name: "Outlook" },
  { src: Microsoft_PowerPoint, name: "PowerPoint" },
  { src: Microsoft_Teams, name: "Teams" },
  { src: Microsoft_Word, name: "Word" },
  { src: Microsoft, name: "Microsoft" },
  { src: Mural, name: "Mural" },
  { src: Nginx, name: "Nginx Server" },
  { src: NodeJS, name: "NodeJS" },
  { src: Notion, name: "Notion" },
  { src: OneDrive, name: "OneDrive" },
  { src: Paypal, name: "Paypal" },
  { src: png, name: "PNG" },
  { src: Power, name: "Power Automate" },
  { src: Quickbooks, name: "Quickbooks" },
  { src: React_JS, name: "React" },
  { src: Redux, name: "Redux" },
  { src: Salesforce, name: "Salesforce" },
  { src: Sanity, name: "Sanity CMS" },
  { src: SASS, name: "SASS" },
  { src: Segment, name: "Segment Analytics" },
  { src: Sharepoint, name: "Microsoft Sharepoint" },
  { src: Shopify, name: "Shopify" },
  { src: ShutterStock, name: "ShutterStock" },
  { src: Slack, name: "Slack" },
  { src: sms, name: "SMS" },
  { src: Spotify, name: "Spotify" },
  { src: Squarespace, name: "SquareSpace" },
  { src: Square, name: "Square" },
  { src: Stripe, name: "Stripe" },
  { src: SVG, name: "SVG" },
  { src: Trello, name: "Trello" },
  { src: Twilio, name: "Twilio" },
  { src: Twitter, name: "Twitter" },
  { src: Typeform2, name: "Typeform" },
  { src: Typescript, name: "TypeScript" },
  { src: Venmo, name: "Venmo" },
  { src: VS_Code, name: "VS Code" },
  { src: Webflow, name: "Webflow" },
  { src: Wix, name: "Wix" },
  { src: Xero, name: "Xero" },
  { src: Youtube, name: "Youtube" },
  { src: Zapier, name: "Zapier" },
  { src: Zendesk, name: "Zendesk" },
  { src: Zoom, name: "Zoom" }
];

export const PrimaryLogos: Logo[] = [
  { src: AWS, name: "AWS" },
  { src: ChatGPT, name: "ChatGPT" },
  { src: Figma, name: "Figma" },
  { src: Google_Ads, name: "Google Ads" },
  { src: Google_Analytics, name: "Google Analytics" },
  { src: Hubspot_CRM, name: "Hubspot" },
  { src: Jotform, name: "Jotform" },
  { src: MailChimp, name: "MailChimp" },
  { src: Power, name: "Power Automate" },
  { src: React_JS, name: "React" },
  { src: Typeform2, name: "Typeform" },
  { src: Webflow, name: "Webflow" },
  { src: Wix, name: "Wix" },
  { src: Zapier, name: "Zapier" }
];

export const WebsitesLeads = [
  { src: Webflow, name: "Webflow" },
  { src: Wix, name: "Wix" },
  { src: Typeform2, name: "Typeform" },
  { src: React_JS, name: "React" },
  { src: Jotform, name: "Jotform" },
  { src: Shopify, name: "Shopify" },
  { src: Squarespace, name: "SquareSpace" },
  { src: LinkTree, name: "LinkTree" },
  { src: Nginx, name: "Nginx Server" },
  { src: NodeJS, name: "NodeJS" },
  { src: Typescript, name: "TypeScript" },
  { src: Javascript, name: "JavaScript" },
  { src: HTML5, name: "HTML5" },
  { src: SASS, name: "SASS" },
  { src: CSS3, name: "CSS3" },
  { src: Redux, name: "Redux" }
];
export const Advertising = [
  { src: Google_Ads, name: "Google Ads" },
  { src: MailChimp, name: "MailChimp" },
  { src: Twilio, name: "Twilio" },
  { src: Facebook, name: "Facebook" },
  { src: sms, name: "SMS" },
  { src: ActiveCampaign, name: "Active Campaign" },
  { src: Instagram, name: "Instagram" },
  { src: Google, name: "Google" },
  { src: Constant_Contact, name: "Constant Contact" },
  { src: LinkedIn, name: "LinkedIn" },
  { src: Meta, name: "Meta" },
  { src: Twitter, name: "Twitter" },
  { src: Youtube, name: "Youtube" }
];
export const Design = [
  { src: Figma, name: "Figma" },
  { src: Canva, name: "Canva" },
  { src: Material_UI, name: "Material UI" },
  { src: Adobe, name: "Adobe" },
  { src: Adobe_XD, name: "Adobe XD" },
  { src: Adobe_Illustrator, name: "Adobe Illustrator" },
  { src: Adobe_Bridge, name: "Adobe Bridge" },
  { src: Adobe_Photoshop, name: "Adobe Photoshop" },
  { src: Adobe_Dimension, name: "Adobe Dimension" },
  { src: Adobe_InDesign, name: "Adobe InDesign" },
  { src: Adobe_Lightroom, name: "Adobe Lightroom" },
  { src: Adobe_Premiere, name: "Adobe Premiere" },
  { src: InVision, name: "InVision" },
  { src: png, name: "PNG" },
  { src: SVG, name: "SVG" },
  { src: ShutterStock, name: "ShutterStock" }
];
export const Automations = [
  { src: Zapier, name: "Zapier" },
  { src: Hubspot_CRM, name: "Hubspot" },
  { src: ChatGPT, name: "ChatGPT" },
  { src: AWS, name: "AWS" },
  { src: Power, name: "Power Automate" },
  { src: Azure, name: "Azure" },
  { src: Salesforce, name: "Salesforce" },
  { src: IFTTT, name: "IFTTT" },
  { src: Airtable, name: "Airtable" },
  { src: Azure_Functions, name: "Azure Functions" },
  { src: Sanity, name: "Sanity CMS" },
  { src: Lambda, name: "AWS Lambda" },
  { src: Google_Analytics, name: "Google Analytics" },
  { src: Google_Optimize, name: "Google Optimize" },
  { src: AddEvent, name: "AddEvent" },
  { src: Calendly, name: "Calendly" },
  { src: Google_Calendar, name: "Google Calendar" }
];
export const DataCommunications = [
  { src: Slack, name: "Slack" },
  { src: Discord, name: "Discord" },
  { src: Jira, name: "Jira" },
  { src: Microsoft_Teams, name: "Microsoft Teams" },
  { src: Atlassian, name: "Atlassian" },
  { src: Gmail, name: "Gmail" },
  { src: Google_Meet, name: "Google Meet" },
  { src: Zoom, name: "Zoom" },
  { src: Google_Chrome, name: "Chrome" },
  { src: Loom, name: "Loom" },
  { src: Microsoft_Outlook, name: "Outlook" },
  { src: Sharepoint, name: "Microsoft Sharepoint" }
];

export const BusinessFinance = [
  { src: Quickbooks, name: "Quickbooks" },
  { src: Venmo, name: "Venmo" },
  { src: ClickUp, name: "ClickUp" },
  { src: Discord, name: "Discord" },
  { src: DocuSign, name: "DocuSign" },
  { src: Google_Drive, name: "Google Drive" },
  { src: Google_My_Business, name: "Google My Business" },
  { src: HelloSign, name: "HelloSign" },
  { src: OneDrive, name: "OneDrive" },
  { src: Paypal, name: "Paypal" },
  { src: Square, name: "Square" },
  { src: Stripe, name: "Stripe" },
  { src: Xero, name: "Xero" }
];

// DEEP COPY
export const GetLogosShuffled = () => {
  const primaryNames = PrimaryLogos.map((logo) => logo.name);
  return JSON.parse(JSON.stringify(PrimaryLogos))
    .sort(() => Math.random() - 0.5)
    .concat(
      JSON.parse(JSON.stringify(AllLogos))
        .filter((logo: Logo) => !primaryNames.includes(logo.name))
        .sort(() => Math.random() - 0.5)
    );
};

// DEEP COPY
export const GetAllLogosShuffled = () =>
  JSON.parse(JSON.stringify(AllLogos)).sort(() => Math.random() - 0.5);
